import { Switch } from '@otp/ui';
import { LoginRuleListItem } from '../../types';
import {
  DisableLoginRuleDocument,
  EnableLoginRuleDocument,
  LoginRulesDocument,
} from 'src/graphql/generated/graphql';
import { useMutation } from '@apollo/client';

type DisableFieldProps = {
  loginRule: LoginRuleListItem;
};

const QUERIES_TO_REFETCH = [LoginRulesDocument];

export const DisableField = ({ loginRule }: DisableFieldProps) => {
  const [enableMutation] = useMutation(EnableLoginRuleDocument, {
    refetchQueries: QUERIES_TO_REFETCH,
  });

  const [disableMutation] = useMutation(DisableLoginRuleDocument, {
    refetchQueries: QUERIES_TO_REFETCH,
  });

  const onChange = (_: any, checked: boolean) => {
    const variables = {
      id: loginRule.id,
      reason: 'Disabled by user',
    };

    if (checked) {
      enableMutation({ variables });
    } else {
      disableMutation({ variables });
    }
  };

  return <Switch checked={!loginRule.isDisabled} onChange={onChange} />;
};
